import { h } from 'preact'
import styles from './timeline.module.css'
import { Heading } from './heading/heading.tsx'
import { Text } from '../text/text.tsx'
import { Image } from '../image/image.tsx'
import { Video } from '../video/video.tsx'
import { Map } from '../map/map.jsx'
import { Spesialmodul } from '../spesialmodul/spesialmodul.jsx'

export const Timeline = ({ content }) => {
  const mappedContent = content.map((el) => {
    const Component = getComponentForType(el.type)
    return <Component {...el} />
  })
  return <div className={styles.timeline}>{mappedContent}</div>
}

function getComponentForType(type) {
  switch (type) {
    case 'Tidspunkt':
      return Heading
    case 'text':
      return Text
    case 'image':
      return Image
    case 'video':
      return Video
    case 'map':
      return Map
    case 'spesialmodul':
      return Spesialmodul
  }
}
